export default "__VITE_ASSET__ILtgAL8l__"